import { capitalize, words } from "lodash-es"
import { DateTime } from "luxon"

export const formatDate = (
  value: string,
  timezone?: string,
  format = "MMM d, yyyy"
) => DateTime.fromISO(value).setZone(timezone).toFormat(format)

export const formatTime = (
  value: string,
  timezone?: string,
  format = "MMM d, yyyy h:mma"
) => DateTime.fromISO(value).setZone(timezone).toFormat(format)

export const formatRelativeTime = (value: string) =>
  DateTime.fromISO(value).toRelative()

export const formatCurrency = (value: number) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD"
  }).format(value)

export const formatCurrencyInCents = (value: number) =>
  formatCurrency(value / 100).replace(".00", "")

export const formatCurrencyWithoutTrailingZeros = (value: number) =>
  formatCurrency(value).replace(/\.00$/, "")

export const formatPercentage = (value: number) => {
  return `${value}%`
}

export const formatPercentageToDecimal = (value: string) => {
  return parseFloat(value.replace("%", "")) / 100
}

export const humanize = (
  string: string,
  { lowerCase }: { lowerCase?: boolean } = {}
) => {
  return words(string)
    .map(w => (lowerCase ? w.toLowerCase() : capitalize(w)))
    .join(" ")
}

export const formatAddressCityStateAndZipCode = (
  city?: string | null,
  state?: string | null,
  zipCode?: string | null
) => {
  const separatedBySpace = [state, zipCode].filter(Boolean).join(" ")
  const separatedByComma = [city, separatedBySpace].filter(Boolean).join(", ")

  return separatedByComma
}
